import { useEffect, useState } from "react";
import api, { API_BASE } from "@/lib/api";
import { ExternalLink, FileText } from "lucide-react";

export default function SitemapsTab({ projectId }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.get(`/sitemaps/${projectId}/summary`).then((r) => setSummary(r.data)).catch(() => {});
  }, [projectId]);

  if (!summary) return <div className="text-xs text-muted-foreground">Loading sitemaps…</div>;

  return (
    <div>
      <div className="border border-border p-4 mb-4">
        <div className="text-[10px] txt-mono uppercase tracking-widest text-muted-foreground">Total indexable URLs</div>
        <div className="stat-num text-3xl text-primary">{summary.total_urls}</div>
        <div className="text-xs text-muted-foreground mt-2">
          {summary.domain
            ? <>Submit <span className="txt-mono text-foreground">{summary.domain}{summary.files[0].url}</span> to Google Search Console.</>
            : <>Set the project <code>domain</code> for absolute URLs in sitemap entries.</>}
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {summary.files.map((f) => (
          <a key={f.name}
            href={`${API_BASE.replace(/\/api$/, "")}${f.url}`}
            target="_blank" rel="noopener noreferrer"
            className="border border-border p-4 hover:border-primary transition-colors group"
          >
            <div className="flex items-start justify-between mb-2">
              <FileText className="w-5 h-5 text-primary" />
              <ExternalLink className="w-3 h-3 text-muted-foreground group-hover:text-primary" />
            </div>
            <div className="text-sm font-medium">{f.name}</div>
            <div className="text-[10px] txt-mono text-muted-foreground mt-1">{f.urls_count} URL{f.urls_count !== 1 ? "s" : ""}</div>
          </a>
        ))}
      </div>
    </div>
  );
}
